/* esm.sh - d3-transition@3.0.1/src/transition/index */
export * from "/*d3-transition@3.0.1/esnext/src/transition/index.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/index.mjs";
